<template>
  <div class="page-login">
    <div class="page-login--layer" style="overflow: hidden;">
      <div class="page-login--content" flex="dir:top main:justify cross:center box:justify" :style="backgroundBg">
        <img src="../../assets/image/login/logo.png" class="logo" />
        <img src="../../assets/image/login/word.png" class="word-img">
        <img src="../../assets/image/login/bear.png" class="bear-img">

        <div class="page-login--content-main z-index" flex="dir:top main:center cross:center">
          <!-- 表单 -->
          <div class="page-login--form" :class="hasH5 ? 'page-login--form-H5' : '' ">
            <div class="title">欢迎登录</div>

            <div class="tab-list">
              <div class="list-item" :class="{middle: tab.value == 1, active: tab.value == currentTab}" 
                v-for="tab in tabList" :key="tab.value" @click="chooseTab(tab)">{{ tab.label }}</div>
            </div>
            
            <div class="slide-item" v-if="currentTab == 1">
              <el-form class="account-form" ref="passwordLoginRef" label-position="top" :rules="passwordLoginForm.rules"
                :model="passwordLoginForm" size="default">
                <el-form-item prop="loginName">
                  <el-input type="text" v-model="passwordLoginForm.loginName" placeholder="请输入账号" name="oauth-username" autocomplete="on"
                    @keyup.enter.native="submit" prefix-icon="el-icon-user-solid">
                  </el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input type="password" v-model="passwordLoginForm.password" placeholder="请输入密码"
                    @keyup.enter.native="submit" prefix-icon="el-icon-edit">
                  </el-input>
                </el-form-item>
                <el-button @click="submit" :loading="loginLoading" type="primary" class="button-login">{{ loginLoading ? '登录中...' : '登录' }}</el-button>
              </el-form>
            </div>

            <div v-if="currentTab == 2">
              <el-form class="code-form" :class="{'slide-item': currentTab == 2}" ref="freePasswordLoginRef" label-position="top" :rules="freePasswordLoginForm.rules"
                :model="freePasswordLoginForm" size="default">
                <el-form-item prop="phone">
                  <el-input type="text" v-model="freePasswordLoginForm.phone" placeholder="请输入手机/工号/用户名" name="oauth-jobname" autocomplete="on"
                    @keyup.enter.native="submit" prefix-icon="el-icon-mobile-phone">
                  </el-input>
                </el-form-item>
                <el-form-item prop="phoneCode">
                  <div class="phone__code">
                    <el-input type="text" v-model="freePasswordLoginForm.phoneCode" placeholder="请输入验证码"
                    @keyup.enter.native="submit" suffix-icon="el-icon-lock">
                  </el-input>
                  <el-button class="code-get-btn" :disabled="validBtnDis" @click="getCode">{{validBtn}}</el-button>
                  </div>

                </el-form-item>
                <el-button @click="submit" :loading="loginLoading" type="primary" class="button-login">{{ loginLoading ? '登录中...' : '登录' }}</el-button>
              </el-form>
            </div>

            <div v-if="currentTab == 3">
              <div id="ding-login" :class="{'slide-item': currentTab == 3}"></div>
            </div>
            <!-- <div @click="changeLogin" class="change-icon">
              <img :src="imgSrc" alt="" />
            </div>
            <el-card shadow="never">
              <div slot="header" class="login-header" style="text-align: center;">
                <img :src="logo" class="logo-img" height="32" />
              </div>
              <div class="loginForm-body" v-if="!isChange">
                <el-tabs v-model="loginType">
                  <el-tab-pane label="密码登录" name="1">
                    <el-form ref="passwordLoginRef" label-position="top" :rules="passwordLoginForm.rules"
                      :model="passwordLoginForm" size="default">
                      <el-form-item prop="loginName">
                        <el-input type="text" v-model="passwordLoginForm.loginName" placeholder="用户名" name="oauth-username" autocomplete="on"
                          @keyup.enter.native="submit" style="height: 50px;" prefix-icon="el-icon-user-solid">
                        </el-input>
                      </el-form-item>
                      <el-form-item prop="password">
                        <el-input type="password" v-model="passwordLoginForm.password" placeholder="密码"
                          @keyup.enter.native="submit" style="height: 50px;" prefix-icon="el-icon-edit">
                        </el-input>
                      </el-form-item>
                      <el-button @click="submit" :loading="loginLoading" type="primary" class="button-login"
                        style="height: 50px;">{{ loginLoading ? '登录中...' : '登录' }}</el-button>
                    </el-form>
                  </el-tab-pane>
                  <el-tab-pane label="钉钉消息验证码" name="2">
                    <el-form ref="freePasswordLoginRef" label-position="top" :rules="freePasswordLoginForm.rules"
                      :model="freePasswordLoginForm" size="default">
                      <el-form-item prop="phone">
                        <el-input type="text" v-model="freePasswordLoginForm.phone" placeholder="请输入手机/工号/用户名" name="oauth-jobname" autocomplete="on"
                          @keyup.enter.native="submit" style="height: 50px;" prefix-icon="el-icon-mobile-phone">
                        </el-input>
                      </el-form-item>
                      <el-form-item prop="phoneCode">
                        <div class="phone__code">
                          <el-input type="text" v-model="freePasswordLoginForm.phoneCode" placeholder="请输入验证码"
                          @keyup.enter.native="submit" style="height: 50px;" suffix-icon="el-icon-lock">
                        </el-input>
                        <el-button :disabled="validBtnDis" @click="getCode">{{validBtn}}</el-button>
                        </div>

                      </el-form-item>
                      <el-button @click="submit" :loading="loginLoading" type="primary" class="button-login"
                        style="height: 50px;">{{ loginLoading ? '登录中...' : '登录' }}</el-button>
                    </el-form>
                  </el-tab-pane>
                </el-tabs>

              </div>
              <div id="ding-login" v-show="isChange"></div>
            </el-card> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import backgroundImg from './../../assets/image/ui/bg.png'
import qrcodeLogin from './../../assets/image/ui/code.png'
import pcLogin from './../../assets/image/ui/pc.png'
import logo from './../../assets/image/ui/logo.png'
// import { animationRunning } from './../../animation/demo-1.js'
// import { rAF } from './../../animation/rAF.js'
import util from '@/libs/util.js'
import { AuthenticationGetDingAppId, GetVerificationCode } from '../../api/systemPrivilege/account'

export default {
  data () {
    return {
      logo,
      backgroundImg,
      redirect: null,
      redirect_uri: null,
      timeInterval: null,
      loginLoading: false,
      isChange: false,
      imgSrc: qrcodeLogin,
      appid: 'dingoat8bgusevgidqftt8',
      // 登录类型
      loginType: '1', // 1密码登录 2免密码登录
      validBtn: '获取验证码',
      validBtnDis: false,
      timer: null,
      // 密码登录-表单
      passwordLoginForm: {
        loginName: '',
        password: '',
        rules: {
          loginName: [
            { required: true, message: '请输入账号', trigger: 'blur' }
          ],
          password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
        }
      },
      // 免密码登录- 表单
      freePasswordLoginForm: {
        phone: '',
        phoneCode: '',
        rules: {
          phone: [
            { required: true, message: '请输入手机/工号/用户名', trigger: 'blur' }
          ],
          phoneCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
        }
      },
      tabList: [
        {label: '钉钉扫码', value: 3},
        {label: '钉钉消息码', value: 2},
        {label: '账号密码', value: 1},
      ],
      currentTab: 3,
    }
  },
  computed: {
    backgroundBg () {
      return {
        // background: `url(${this.backgroundImg}) no-repeat`,
        backgroundSize: '100% 100%'
      }
    },
    hasH5 () {
      let hasH5 = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) // 判断是否为H5浏览器
      return hasH5
    }
  },
  created () {
    let selectTab = util.cookies.get('login-tab');
    if(selectTab){
      this.chooseTab({value: selectTab});
    }else{
      this.isChange = false;
      this.changeLogin();
    }
    this.clearAllCookies()
  },
  mounted () {
    this.initDDCode()
  },
  methods: {
    ...mapActions('d2admin/account', ['login', 'freeLogin']),
    // 提交登录信息
    submit () {
      // 密码登录
      if (this.loginType === '1') {
        this.passwordLoginFn()
      }
      // 免密码登录
      if (this.loginType === '2') {
        this.freePasswordLoginFn()
      }
    },
    chooseTab(tab){
      this.currentTab = tab.value;
      this.loginType = tab.value + '';
      if(tab.value == 3) {
        this.isChange = false;
        this.changeLogin();
      }
    },
    // 切换登录
    changeLogin () {
      const _self = this
      if (this.isChange) {
        this.isChange = false
        this.loginType = '2'
        this.imgSrc = qrcodeLogin
      } else {
        this.isChange = true
        this.imgSrc = pcLogin
        // let router = this.$route // 不使用this.$route.query，改为util.getUrlParams()方法获取URL参数值。避免因解码原因，导致路由跳转后，query参数丢失
        let urlParams = util.getUrlParams()
        if (Object.keys(urlParams).length) {
          for (let key in urlParams) {
            sessionStorage.setItem(key, urlParams[key])
          }
        }

        let url = `${process.env.VUE_APP_SCAN_CODE}` // #/dingding?
        // let url = `https://t3-oauth.52rental.com/#/login` // #/dingding?
        this.redirect = encodeURIComponent(url)
        this.redirect_uri = encodeURIComponent(
          `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${_self.appid}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${_self.redirect}`
        )
        // 生成二维码 等待扫码登录
        this.$nextTick(() => {
          let obj = DDLogin({
            id: 'ding-login',
            goto: _self.redirect_uri,
            width: '230',
            height: '300',
            style:
              'border: none;background-color:transparent;position: absolute;top: 75px;'
          })
          // 重置扫码登录框的样式，让登录框居中
          let box = document.getElementById('ding-login')
          // box.querySelector('iframe').style.margin = 'absolute'
          box.querySelector('iframe').style.top = '0'
          box.querySelector('iframe').style.bottom = '0'
          box.querySelector('iframe').style.left = '0'
          box.querySelector('iframe').style.right = '0'
          box.querySelector('iframe').style.margin = '0 auto'
          let hanndleMessage = function (event) {
            let origin = event.origin
            // 判断是否来自ddLogin扫码事件
            if (origin === 'https://login.dingtalk.com') {
              let loginTmpCode = event.data
              let url =
                'https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=' +
                _self.appid +
                '&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=' +
                _self.redirect_uri +
                '&loginTmpCode=' +
                loginTmpCode
              window.location.href = url
            }
          }
          if (typeof window.addEventListener !== 'undefined') {
            window.addEventListener('message', hanndleMessage, false)
          } else if (typeof window.attachEvent !== 'undefined') {
            window.attachEvent('onmessage', hanndleMessage)
          }
        })
      }
    },
    async initDDCode () {
      await this._authenticationGetDingAppId()
      if (util.isLoginByDingDing()) this.changeLogin()
    },
    _authenticationGetDingAppId () {
      return new Promise(async resolve => {
        AuthenticationGetDingAppId().then(res => {
          this.appid = res.data
          resolve(res.data)
        })
      })
    },
    // 访问登录页面，清除以前存储的Cookie信息。减少页面闪退情形
    clearAllCookies () {
      // 删除cookie
      util.cookies.remove('token', {
        domain: '52rental.com',
        path: '/'
      })
      util.cookies.remove('uuid', {
        domain: '52rental.com',
        path: '/'
      })
      util.cookies.remove('oauth_login_by_dingding')
    },
    // 判断跳转哪个系统
    handleServerName (ru) {
      let serverName = 'oauth-server'
      if (ru) {
        if (ru.indexOf('product') > -1) {
          serverName = 'product-server'
        } else if (ru.indexOf('workflow') > -1) {
          serverName = 'workflow-server'
        } else if (ru.indexOf('coupon') > -1) {
          serverName = 'coupon-server'
        } else if (ru.indexOf('contract') > -1) {
          serverName = 'contract-server'
        } else if (ru.indexOf('risk') > -1) {
          serverName = 'risk-system-server'
        } else if (ru.indexOf('man') > -1) {
          serverName = 'mall-service'
        }
      }

      return serverName
    },
    // 调取 登录结构后的处理和判断
    handleAfterLogin (res, ru) {
      // 校验是否设置了强制钉钉扫码登录权限（此权限在OMS中设置）
      if (res.code === 'AUTH_000009') {
        this.loginLoading = false
        this.$message.error(res.message || '您需要使用钉钉扫码登录')
        util.setLoginByDingDing()
        this.changeLogin()
        return
      }
      util.cookies.set('login-tab', this.currentTab);
      if (ru) {
        ru = decodeURIComponent(ru)
        let postToken = util.getUrlPara(ru, 'post_token')
        if (postToken === '1') {
          ru += '&token=' + res.data.token
        }
        window.location.href = ru// decodeURIComponent(ru)
        return
      }
      // 重定向对象不存在则返回顶层路径
      this.$router.replace(this.$route.query.redirect || '/')
    },
    // 密码登录
    passwordLoginFn () {
      this.$refs.passwordLoginRef.validate(async valid => {
        if (valid) {
          let ru = await util.getUrlPara(window.location.href, 'ru')
          let serverName = await this.handleServerName(ru)

          this.loginLoading = true
          const { loginName, password } = this.passwordLoginForm
          let postParams = Object.assign({}, { vm: this, loginName, password, serverName })
          this.login(postParams)
            .then((res) => {
              this.handleAfterLogin(res, ru)
            })
            .catch(() => {
              this.loginLoading = false
            })
        }
      })
    },
    // 免密码登录
    freePasswordLoginFn () {
      this.$refs.freePasswordLoginRef.validate(async valid => {
        if (valid) {
          let ru = await util.getUrlPara(window.location.href, 'ru')
          let serverName = await this.handleServerName(ru)

          this.loginLoading = true

          const { phone, phoneCode } = this.freePasswordLoginForm
          let postParams = Object.assign({}, { vm: this, loginName: phone, verificationCode: phoneCode, serverName })
          this.freeLogin(postParams).then(res => {
            this.handleAfterLogin(res, ru)
          })
            .catch(() => {
              this.loginLoading = false
              this.clearTackBtn()
            })
        }
      })
    },
    // 验证码倒数60秒
    tackBtn () {
      let time = 60
      this.validBtnDis = true 
      this.timer = setInterval(() => {
        if (time === 0) {
          clearInterval(this.timer)
          this.validBtn = '获取验证码'
          this.validBtnDis = false
        } else {
          this.validBtnDis = true
          this.validBtn = time + '秒后重试'
          time--
        }
      }, 1000)
      // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
      this.$once('hook:beforeDestroy', () => {
        clearInterval(this.timer)
      })
    },
    // 获取验证码 并只验证手机号 是否正确
    getCode () {
      this.$refs['freePasswordLoginRef'].validateField('phone', (err) => {
        if (!err) {
          this.tackBtn() // 验证码倒数
          GetVerificationCode({ loginName: this.freePasswordLoginForm.phone }).then(res => {
            if (res.success) {
              this.verificationCode = res.data
              return false
            }
            this.clearTackBtn()
          }).catch(() => {
            this.clearTackBtn()
          })
        }
      })
    },
    // 清除倒计时
    clearTackBtn () {
      clearInterval(this.timer)
      this.validBtn = '获取验证码'
      this.validBtnDis = false
    }
  }
}
</script>

<style lang="scss">
.page-login {
  @extend %unable-select;
  $backgroundColor: #f0f2f5;
  // ---
  background-color: $backgroundColor;
  height: 100%;
  cursor: initial;
  position: relative;
  // 层
  .page-login--layer {
    @extend %full;
    overflow: auto;
  }
  .page-login--layer-area {
    overflow: hidden;
  }
  // 时间
  .page-login--layer-time {
    font-size: 24em;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.03);
    overflow: hidden;
  }
  // 登陆页面控件的容器
  .page-login--content {
    height: 100%;
    min-height: 500px;
    position: relative;
    background-size: cover;
    background-image: url('../../assets/image/login/background.png');
    .logo{
      position: absolute;
      top: 4.2vh;
      left: 4.2vw;
      width: 12vw;
      height: auto;
    }
    .word-img{
      position: absolute;
      left: 4.2vw;
      top: 31.5vh;
      width: 31vw;
      height: auto;
    }
    .bear-img{
      position: absolute;
      bottom: 0;
      right: 0;
      width: 30vw;
      height: auto;
    }
  }
  // 登录表单
  .page-login--form {
    width: 460px;
    height: 540px;
    position: absolute;
    padding: 51px 36px 89px 44px;
    box-sizing: border-box;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 6px;
    box-shadow: 0px 4px 19px 1px rgba(0,54,128,0.08);
    .title{
      font-size: 28px;
      font-weight: bold;
      color: #223350;
      margin-bottom: 40px;
    }
    .tab-list{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .list-item{
        position: relative;
        text-align: center;
        color: #707980;
        font-size: 22px;
        padding-bottom: 14px;
        cursor: pointer;
        &::after{
          content: "";
          position: absolute;
          bottom: 2px;
          left: 50%;
          margin-left: -15px;
          width: 0px;
          height: 4px;
          background-color: #fff;
          border-radius: 2px;
          transition: 0.3s;
        }
        &.active{
          color: #1F1F1F;
          font-weight: bold;
          &::after{
            width: 30px;
            background-color: #009FE8;
          }
        }
      }
    }
    .account-form{
      margin-top: 56px;
      .el-input{
        font-size: 16px;
      }
      .el-input__prefix{
        left: 8px;
      }
      .el-input__inner{
        padding-left: 40px;
        height: 54px;
        line-height: 54px;
      }
    }
    // 去除默认样式 start
    .el-card.is-always-shadow {
      border: none;
      box-shadow: none;
      background: #fff;
    }
    .el-card__header,
    .el-card__body {
      border: none;
      z-index: 10;
      background: #fff;
    }
    // 去除默认样式 end
    .loginForm-body {
      background: #fff;
    }
    // 切换登录和扫码
    .change-icon {
      position: absolute;
      top: 0;
      right: 0;
      height: 73px;
      width: 73px;
      img {
        height: 73px;
        width: 73px;
      }
    }
    // 卡片
    .el-card {
      border: none;
      margin-bottom: 15px;
      .el-card__body {
        padding: 30px 120px 40px 120px;
        background: #fff;
        border: none;
      }
    }
    // .el-input {
    //   input {
    //     height: 50px;
    //   }
    // }
    // 登录按钮
    .button-login {
      width: 100%;
      margin-top: 40px;
      background-color: #009FE8;
      border-radius: 8px;
      height: 56px;
      font-size: 20px;
      color: #fff;
      letter-spacing: 2px;
      // line-height: 64px;
    }
    // 登陆选项
    .page-login--options {
      margin: 0px;
      padding: 0px;
      font-size: 14px;
      color: $color-primary;
      margin-bottom: 15px;
      font-weight: bold;
      
    }
    .page-login--quick {
      width: 100%;
    }
    // 输入框左边的图表区域缩窄
    .el-input-group__prepend {
      padding: 0px 14px;
    }
    .login-code {
      height: 40px - 2px;
      display: block;
      margin: 0px -20px;
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }
    .phone__code{
      display: flex;
    }
  }
  // h5浏览器-样式变动
  .page-login--form-H5{
    width: 90%;
    padding: 20px;
    min-height: 420px;
    .title{
      margin-bottom: 24px;
    }
    .code-form, .account-form{
      margin-top: 24px;
    }
    .button-login{
      margin-top: 24px;
    }
    // 卡片
    .el-card {
      .el-card__body {
        padding: 15px;
      }
    }
  }
}
.z-index {
  z-index: 10;
}
#ding-login{
  display: flex;
  justify-content: center;
}
.ding-login-wrap {
  box-sizing: border-box;
  width: 590px;
  display: flex;
  justify-content: center;
  height: 400px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  .login-header {
    height: 72px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #ebeef5;
  }
}
.code-form{
  margin-top: 56px;
  .el-input{
    font-size: 16px;
    .el-input__inner{
      height: 54px;
      line-height: 54px;
    }
  }
  .phone__code{
    .el-input__inner{
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      
    }
    .code-get-btn{
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border: 1px solid #DCDFE6;
      border-left: none;
      height: 54px;
    }
  }
}
@keyframes slide {
  0%{
    opacity: 0;
    transform: translateX(-15px);
  }
  100%{
    opacity: 1;
    transform: translateX(0);
  }
}

.slide-item{
  animation: slide 0.3s linear;
}
</style>
